export const glassboxProd = {
  src: `https://cdn.gbqofs.com/mt/ab-inbev/tada_seller/p/detector-dom.min.js`,
  dataClsconfig: `reportURI=https://report.c1101.gbqofs.io/xw5bof6l/reporting/ee418e1d-955b-5b92-cd10-6a9b9ff8e283/cls_report`
};

export const glassboxRLS = {
  src: `https://cdn.gbqofs.com/mt/ab-inbev/ze_delivery/rls/config.js`,
  dataClsconfig: `reportURI=https://report.c1101.gbqofs.io/xw5bof6l/reporting/bc2af246-c04d-0bcc-908f-eceb6bd9db35/cls_report`
};

export const glassboxUat = {
  src: `https://cdn.gbqofs.com/mt/ab-inbev/ze_delivery/u/config.js`,
  dataClsconfig: `reportURI=https://report.c1101.gbqofs.io/xw5bof6l/reporting/bf3aaff7-f661-6304-8fe3-e1077ece0440/cls_report`
};